bz_app.directive('propertiesListDirective', [
  '$rootScope',
  '$sce',
  'propertiesService',
  'markerService',
  'googleMapsStreetViewService',
  'trackPermitMapService',
  'urlService',
  'urlConstants',
  function (
    $rootScope,
    $sce,
    propertiesService,
    markerService,
    googleMapsStreetViewService,
    trackPermitMapService,
    urlService,
    urlConstants
  ) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        property: '=',
        index: '<',
      },
      templateUrl: urlService.templateUrl(
        'properties/directives/properties_list'
      ),
      link: function ($scope, element) {
        $scope.focusPin = function (street) {
          markerService.hover(propertiesService.getPinByAddress(street))
        }

        $scope.unfocusPin = function (street) {
          markerService.unhover(propertiesService.getPinByAddress(street))
        }

        $scope.contractorProfileLink = function (contractor) {
          return (
            urlConstants.contractor.profileURL + contractor.contractor_alias
          )
        }

        $scope.contractorInfo = function (property) {
          if (typeof property != 'undefined') {
            for (var i = 0; i < property.relevant_permits.length; i++) {
              var contractor = property.relevant_permits[i]
              if (
                typeof contractor != 'undefined' &&
                contractor.contractor_alias
              ) {
                return $sce.trustAsHtml(
                  'Latest Work by <a target="_blank" href="' +
                    $scope.contractorProfileLink(contractor) +
                    '">' +
                    contractor.business_name +
                    '</a>'
                )
              }
            }
          }
          return $sce.trustAsHtml('')
        }

        $scope.zoomProperty = function (property) {
          if (!isMobile.check()) {
            $rootScope.$broadcast('zoom-property', property, false)
          }
        }

        $rootScope.$on('pin.clicked', function (event, marker) {
          //move selected property to top of properties list
          if (typeof marker.property !== 'undefined') {
            marker.property.selected = true
            $scope.$digest()
          }
        })

        $rootScope.$on('pin.unselected', function (event, marker) {
          marker.property.selected = false
        })

        $scope.streetAddress = function (property) {
          var street_address = property.street.toLowerCase().titleCase()
          return $sce.trustAsHtml(street_address)
        }

        $scope.trackClick = function (property) {
          trackPermitMapService.viewPropertyPage(property, 'sidebar')
        }
      },
    }
  },
])
